<template>
  <div id="rule-page">
    <div class="logo">
      <img
        :src="logoObj.src"
        alt=""
        :style="logoObj.style"
      >
    </div>
    <div class="logoTitle" v-if="this.logoTitle">
      {{this.logoTitle}}
    </div>
    <div class="ruleList">
      <ul>
        <li
          v-for="(item,index) in ruleList"
          :key="index"
        >
          <div class="iconBox">
            <van-icon
              :name="item.icon"
              color="#049EA3"
            />
          </div>
          <div class="ruleText">{{item.des}}</div>
        </li>
      </ul>
    </div>
    <div class="footer">
      <div
        class="footerInner"
        @click="read"
      >
        <van-checkbox
          v-model="checked"
          checked-color="#049EA3"
          shape="square"
          icon-size="16px"
        ></van-checkbox>
        <span :class="{isRead:checked,readText:true}">已阅读</span>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import ComConfig from '../../utils/comConfig'
export default {
  data() {
    return {
      checked: false,
      logoObj:{
        src:require('../../assets/images/logo.png'),
        style:''
      },
      logoTitle:'让你的观点 产生价值',
      ruleList: [
        {
          icon: 'label-o',
          des:
            '受企业的委托，蜂鸟正在收集消费者对商家、品牌、产品的认知、体验和建议。'
        },
        {
          icon: 'label-o',
          des:
            '在这里，您分享的每个观点都将得到重视和酬谢，您完整地答完的每一份问卷都将获得现金报酬，通过微信零钱在48小时内支付！'
        },
        // {
        //   icon: 'label-o',
        //   des:
        //     '我们希望您把蜂鸟推荐给你的朋友，让他们也可以有偿反馈意见，更重要的是您将获取好友酬金金额10%的佣金奖励，同样是“当日即付”哦！'
        // },
        {
          icon: 'label-o',
          des:
            '我们希望您把蜂鸟推荐给你的朋友，让他们也可以有偿反馈意见。'
        },
        {
          icon: 'label-o',
          des:
            '我们希望先了解您的基本情况，以便向您推送合适的任务，在正式答题前，须先请您填答《基础信息问卷》；'
        },
        {
          icon: 'label-o',
          des:
            '您应该知道，不真实的信息是无法使用的，如果您填写的信息存在失真或矛盾，您的意见将不被采纳，也无法获取酬金。'
        }
      ]
    }
  },
  components: {},
  beforeCreate() {
    // 先触发登录
    $api.getPanel()
  },
  created() {
    let env = process.env.VUE_APP_Version
    if(env!=='pro'){
      ComConfig.forEach(item=>{
        if(item.env === env){
          this.logoObj.src = require(`../../assets/images/${item.rulePage.ruleLogo.logoName}`)
          this.logoObj.style = item.rulePage.ruleLogo.style
          this.logoTitle = item.rulePage.logoTitle
          this.ruleList = item.rulePage.ruleList
        }
      })
    }
  },
  methods: {
    // 阅读规则操作
    read() {
      this.checked = true
      if (this.checked) {
        $api.updateRuleState().then(res => {
          if (res) {
            Cookies.set('isRead', true, { expires: 30 })
            window.location.replace(this.$route.query.toPath)
          }
        })
      }
    }
  }
}
</script>
<style lang='less'>
#rule-page {
  width: 100%;
  height: 100%;
  //overflow: hidden;
  .logo {
    // height: 30px;
    margin-top: 30px;
    width: 100%;
    img {
      margin: 0 auto;
      display: block;
      width: 180px;
      height: 30px;
    }
  }
  .logoTitle {
    font-size: 16px;
    line-height: 30px;
    padding-top: 10px;
    color: #ff532e;
    font-weight: bold;
    text-align: center;
  }
  .ruleList {
    font-size: 12px;
    padding: 10px;
    li {
      .iconBox {
        float: left;
        font-size: 16px;
        width: 20px;
        padding: 10px 0;
        line-height: 20px;
      }
      .ruleText {
        margin-left: 20px;
        padding: 5px 0;
        font-size: 12px;
        line-height: 20px;
      }
    }
  }
  .readText {
    color: #fff;
    &.isRead {
      color: @green;
    }
    margin-left: 5px;
  }
  .footer {
    height: 40px;
    position: absolute;
    left: 0;
    bottom: 20px;
    right: 0;
    .footerInner {
      height: 40px;
      font-size: 12px;
      width: 100px;
      margin: 0 auto;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      .van-checkbox {
        background: #fff;
      }
    }
  }
}
</style>
